import {Component} from '@angular/core';
import { NavController, NavParams ,ViewController ,ToastController} from 'ionic-angular';
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {Events} from 'ionic-angular';
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'dropship-location-add-popup',
  templateUrl: 'dropship-location-add-popup.html'
})
export class DropshipLocationAddPopup{

  dropshipLocation : any;
  user:any;
  callStatus = 0;

  formStatus = false;
  buttonText = "";
  firstName = "";
  lastName = "";
  phone = "";
  pageTitle = "";
  emailReadOnly= false;
  userNameReadOnly= false;


  userUnique = true; // true for update only
  countries = [];
  provinces = [];
  companyName = ""

  constructor(private nav:NavController,
              private api:Api,
              private params: NavParams,
              private cartManager:CartManager,
              private msgManager:MsgManager,
              private viewController:ViewController,
              private toastController:ToastController,
              private events:Events,
              private gVLogger: GVLogger){
    this.dropshipLocation = this.params.get("dropshipLocation");
    this.gVLogger.log("dropship location : " + this.dropshipLocation);
    this.companyName = this.params.get("companyName");

    console.log("VVVVVV " + this.companyName)
    this.dropshipLocation.companyName = this.companyName
    this.getCountries();
    this.getProvincesWhileEditing(this.dropshipLocation.country)
  }


  addAdress(){
    this.gVLogger.log(this.dropshipLocation);
    if(this.validateForm())
      this.viewController.dismiss(this.dropshipLocation);
  }


  validateForm(){
    if(this.dropshipLocation.state == "" || this.dropshipLocation.country == "" || this.dropshipLocation.city == ""
    ){
      this.gVLogger.log("form validation failed");

      this.toastMsg("City, State and Country cannot not be empty");
      return false;
    }else{
      this.gVLogger.log("form validation pass");
      return true;
    }
  }

  cancelPopup(){
    this.viewController.dismiss(false);
  }

  toastMsg(msg){
    let taost = this.toastController.create({
      message: msg,
      duration: 3000
    });
    taost.present();
  }
  getCountries(){
    this.api.getRA("/api/v1/codes/all/0").subscribe(result=>{
      this.countries=result.json().data;
      console.log("CountryCodes from RA Service", this.countries);
    },err=>{
      console.log("Error", err);
    });
  }


  getProvinces(location,event){
    // if (event.isUserInput){
    location.state = ""
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+event)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{

          this.provinces =  data.json().lookups

          // this.paymentProcessingCode = data.json().lookups;
        }
      },err=>{
        console.log("Error", err);
      });
    // }

  }

  getProvincesWhileEditing(abbreviation){

    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+abbreviation)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{
          this.provinces =  data.json().lookups
        }
      },err=>{
        console.log("Error", err);
      });

  }

}



// WEBPACK FOOTER //
// ./src/pages/dropship-location-add-popup/dropship-location-add-popup.ts